export default __webpack_public_path__ + "static/media/polzP.68a24fbe.jpg";